import { getChinaAndroidTrialProductId } from '@forest/paywall-core'
import { platform } from '~/lib/params'
import { api } from '~/services/api'
import { $chinaAndroidTrialEligibility } from '~/store'
import type { OwnPurchaseStatsResponse } from '~/types'

const CHINA_ANDROID_TRIAL_PRODUCT_ID = getChinaAndroidTrialProductId(
  import.meta.env.MODE,
)

export async function getRemoteStates(userId: number): Promise<{
  chinaAndroidTrialEligibility: 'unavailable' | 'available'
}> {
  if (import.meta.env.DEV) {
    $chinaAndroidTrialEligibility.set('unavailable')
    return {
      chinaAndroidTrialEligibility: 'unavailable',
    }
  }

  let taskGetChinaAndroidTrialEligibility: Promise<'unavailable' | 'available'>
  if (platform === 'china_android' && CHINA_ANDROID_TRIAL_PRODUCT_ID) {
    taskGetChinaAndroidTrialEligibility = api.service
      .get(
        `store/users/${userId}/product/${CHINA_ANDROID_TRIAL_PRODUCT_ID}/own-purchase-stats`,
      )
      .json<OwnPurchaseStatsResponse>()
      .then(({ stats }) => {
        return stats.total_count > 0 ? 'unavailable' : 'available'
      })
  } else {
    taskGetChinaAndroidTrialEligibility = Promise.resolve('unavailable')
  }

  const chinaAndroidTrialEligibility = await taskGetChinaAndroidTrialEligibility

  $chinaAndroidTrialEligibility.set(chinaAndroidTrialEligibility)

  return {
    chinaAndroidTrialEligibility,
  }
}
